import { Profile } from '../types';

export const profile: Profile = {
  name: 'ماهر ملحم',
  title: 'مهندس ذكاء اصطناعي أول',
  subtitle: 'أبني أنظمة ذكاء اصطناعي خاصة، بنية LLM، وتطبيقات ذكية',
  tagline: 'أصمّم وأبني حلول ذكاء اصطناعي جاهزة للإنتاج — من نشر LLM على بنية GPU خاصة إلى سير عمل AI وتطبيقات ذكية.',
  location: 'الرياض، المملكة العربية السعودية',
  email: 'maher.malhem2@gmail.com',
  photo: '/images/profile/maher.png',
  resumePhoto: '/images/profile/maher_resume.png',
  yearsOfExperience: 7,
  careerStartYear: 2019,
  resumePdf: '/resume/resume.pdf',
  seo: {
    title: 'ماهر ملحم — مهندس ذكاء اصطناعي أول | أنظمة LLM خاصة',
    description:
      'ماهر ملحم — مهندس ذكاء اصطناعي أول بـ 7+ سنوات خبرة. أصمّم وأبني حلول AI جاهزة للإنتاج: نشر LLM على بنية GPU خاصة، سير عمل n8n، NestJS/React، وتطبيقات ذكية.',
    ogImage: '/images/profile/maher.png',
    url: '[أضف رابط الموقع]',
  },
  hero: {
    greeting: 'مرحباً، أنا',
    heading: 'ماهر ملحم',
    subtitle:
      'أصمّم وأبني حلول ذكاء اصطناعي جاهزة للإنتاج — من نشر LLM على بنية GPU خاصة إلى سير عمل AI وخدمات خلفية وتطبيقات ذكية.',
    introduction: [
      'منذ 2019 وأنا أبني منتجات برمجية حقيقية — من الموبايل والFull-Stack إلى هندسة أنظمة الذكاء الاصطناعي الخاصة. اليوم أركز على ما يحدث فرقاً فعلياً: LLM على بنية GPU محلية، أتمتة n8n، ومنصات AI آمنة دون الاعتماد على APIs خارجية.',
      'في جامعة بيشة طوّرت منصة شات بوت AI خاصة (On-Premise) على خوادم الجامعة — Docker، NestJS، React، وn8n — لدعم خدمات المستفيدين ومتطلبات التحول الرقمي.',
      'إذا كان لديك مشروع AI، بنية LLM، أو منتج يحتاج هندسة من البداية للنهاية — يسعدني أن أسمع قصتك.',
    ],
  },
  socialLinks: [
    { name: 'LinkedIn', url: 'https://www.linkedin.com/in/mahermalhem/', icon: 'linkedin' },
    { name: 'GitHub', url: 'https://github.com/mahermalhem', icon: 'github' },
    { name: 'Email', url: 'mailto:maher.malhem2@gmail.com', icon: 'email' },
  ],
  professionalSummary:
    'مهندس ذكاء اصطناعي أول ومهندس برمجيات بـ 7+ سنوات خبرة منذ 2019. أصمّم وأبني حلول AI جاهزة للإنتاج — من نشر LLM على بنية GPU خاصة إلى بناء سير عمل ذكاء اصطناعي، خدمات NestJS، ولوحات React وتطبيقات ذكية. أعمل على أنظمة AI من طرف إلى طرف، وليس مجرد ربط API خارجي.',
  education: [
    {
      institution: '[أضف المؤسسة]',
      degree: '[أضف الدرجة]',
      field: '[أضف التخصص]',
      startYear: '[السنة]',
      endYear: '[السنة]',
      description: '[أضف الوصف]',
    },
  ],
  awards: [],
};
